import PropTypes from 'prop-types';
import SpinnerSource from './spinnerSource.inner';

const Spinner = ({ size, variant }) => {
  const CurrentSpinner =
    SpinnerSource[`${variant}`] || SpinnerSource['primary'];

  const spinnerSize = {
    sm: {
      width: 18,
      height: 18,
    },
    md: {
      width: 24,
      height: 24,
    },
  };

  return <CurrentSpinner {...(spinnerSize[size] || spinnerSize.md)} />;
};

Spinner.defaultProps = {
  size: 'md',
  variant: 'primary',
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['md', 'sm']),
  variant: PropTypes.oneOf(['primary', 'neutral']),
};

export default Spinner;
